// extracted by mini-css-extract-plugin
export var numpadContainer = "_m2-1";
export var phoneButton = "_m2-0";